var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _line, _line2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReligion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.94284 9.80282C3.94284 6.43688 6.82447 3.70825 10.3791 3.70825C13.9338 3.70825 16.8154 6.43688 16.8154 9.80282",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.76392 11.6011C9.93217 10.5408 10.1947 8.88603 10.1947 8.88603C9.95881 8.5405 9.80909 8.42593 9.43252 8.7335L7.21213 13.2179V16.2991C7.13783 16.6672 7.00688 16.7621 6.68189 16.8177C6.35485 16.3946 6.16855 16.245 5.82025 16.6346L2.9702 18.16C2.60641 18.2393 2.45194 18.3567 2.4731 18.7701V21.1801C2.53259 21.4987 2.64416 21.6237 2.9702 21.7597H9.06798C9.33991 21.6452 9.41999 21.5518 9.43252 21.3326L7.87494 18.9226L8.76972 17.7024L9.23368 17.3668C9.99766 17.3743 10.1572 17.1756 10.1947 16.6346V12.0892C9.70894 11.6466 9.47413 11.7618 9.06798 12.0892V14.1636",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3455 11.6011C11.1772 10.5408 10.9146 8.88603 10.9146 8.88603C11.1506 8.5405 11.3003 8.42593 11.6769 8.7335L13.8972 13.2179V16.2991C13.9715 16.6672 14.1025 16.7621 14.4275 16.8177C14.7545 16.3946 14.9408 16.245 15.2891 16.6346L18.1392 18.16C18.503 18.2393 18.6574 18.3567 18.6363 18.7701V21.1801C18.5768 21.4987 18.4652 21.6237 18.1392 21.7597H12.0414C11.7695 21.6452 11.6894 21.5518 11.6769 21.3326L13.2344 18.9226L12.3397 17.7024L11.8757 17.3668C11.1117 17.3743 10.9521 17.1756 10.9146 16.6346V12.0892C11.4004 11.6466 11.6352 11.7618 12.0414 12.0892V14.1636",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5645 1V2.35435",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4585 1.67688L13.8737 2.79421",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.51611 1.67688L7.10091 2.79421",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.57373 3.37048L4.53321 4.24114",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4702 6.12097L18.2615 6.66877",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1.36963 6.07874L2.61142 6.55972",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20 9.46448L18.6528 9.46448",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1 9.46448L2.34723 9.46448",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4238 3.70825L16.4455 4.56091",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 6.26197,
    y1: 16.5889,
    x2: 8.103,
    y2: 19.1414,
    stroke: "white"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 6.26197,
    y1: 16.5889,
    x2: 8.103,
    y2: 19.1414,
    stroke: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 3.14718,
    y2: -1,
    transform: "matrix(-0.514454 0.857518 0.857518 0.514454 15.0459 16.7607)",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 3.14718,
    y2: -1,
    transform: "matrix(-0.514454 0.857518 0.857518 0.514454 15.0459 16.7607)",
    stroke: "white",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReligion);
export default __webpack_public_path__ + "static/media/religion.ab231debe6871648389004fddc7d1d14.svg";
export { ForwardRef as ReactComponent };